// Slider

jQuery(document).ready(function ($) {

    $('.js-project-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        appendDots: $('.js-slider-dots'),
        adaptiveHeight: false,
        speed: 600,
        autoplay: false,
        infinite: true
    });

});